import { computed } from 'vue';
import useSortableGrid from './useSortableGrid';
import { ComputedRef } from '../types/sortable-grid.definitions'; // eslint-disable-line no-unused-vars

/**
 *
 * @param {number} index
 * @returns {ComputedRef<string>}
 */
export default function useProductThumbnailCss(index) {
  const { model } = useSortableGrid();
  const { meta } = model.value;
  const { isMobileSingleColumnMode } = meta;

  return computed(() => {
    let _classes = '';
    /* istanbul ignore else */
    if (isMobileSingleColumnMode) {
      _classes += 'small-12 ';
    }
    /* istanbul ignore else */
    if (index === 3) {
      _classes += 'sticky-header-observer';
    }

    return _classes;
  });
}
